import { useState, useEffect } from "react";
import { Container, Table, Button } from "react-bootstrap";
import ModalBanner from "./modalBanner";
import axios from "axios";
import { PencilFill, TrashFill } from "react-bootstrap-icons";
import Swal from "sweetalert2";
import { API } from "../../../../../api/URL_API";

function BannerAdmin() {
  const [banners, setBanners] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingBanner, setEditingBanner] = useState(null);

  const fetchBanners = async () => {
    try {
      const response = await axios.get(`${API}/api/banners`);
      console.log("📥 Banners recibidos:", response.data);
      setBanners(response.data);
    } catch (error) {
      console.error("❌ Error al cargar banners:", error);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  const handleDeleteBanner = async (idBanner) => {
    const result = await Swal.fire({
      title: "¿Eliminar banner?",
      text: "Esta acción no se puede deshacer",
      icon: "warning",
      showCancelButton: true,
      iconColor: '#f4bd61',
      confirmButtonColor: '#2c4cc4',
      cancelButtonColor: '#da292e',
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });

    if (!result.isConfirmed) return;

    try {
      await axios.delete(
        `${API}/api/banners/${idBanner}`
      );

      Swal.fire({
        icon: "success",
        title: "Banner eliminado",
        text: "El banner fue eliminado correctamente",
        timer: 2000,
        showConfirmButton: false,
        iconColor: '#2fb380',
      });

      fetchBanners(); // refrescar lista

    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message ||
          "No se pudo eliminar el banner",
        confirmButtonColor: "#dc3545",
        iconColor: '#da292e',
      });

      console.error("❌ Error al eliminar banner:", error);
    }
  };

  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="fw-bold text-black">Administración de Banners</h2>
        <Button variant="danger" onClick={() => setShowModal(true)}>
          Nuevo Banner
        </Button>
      </div>

      <Table
        responsive
        hover
        striped
        className="mb-0 align-middle"
      >
        <thead className="table-light">
          <tr>
            <th>Imagen</th>
            <th>Link</th>
            <th className="text-center" style={{ width: "140px" }}>
              Acciones
            </th>
          </tr>
        </thead>

        <tbody>
          {banners.length === 0 && (
            <tr>
              <td colSpan="3" className="text-center">
                No hay banners cargados
              </td>
            </tr>
          )}

          {banners.map((banner) => (
            <tr key={banner.idBanner}>
              <td>
                <img
                  src={banner.imageUrl}
                  alt="banner"
                  className="rounded border"
                  style={{
                    width: "90px",
                    objectFit: "cover",
                    cursor: "pointer"
                  }}
                  onClick={() =>
                    Swal.fire({
                      imageUrl: banner.imageUrl,
                      imageAlt: "Banner",
                      showConfirmButton: false,
                      background: "#000",
                      width: "auto",
                    })
                  }
                />
              </td>

              <td>{banner.link}</td>

              <td>
                <Button
                  variant="link"
                  className="text-warning"
                  onClick={() => {
                    setEditingBanner(banner);
                    setShowModal(true);
                  }}
                >
                  <PencilFill size={18} />
                </Button>

                <Button
                  variant="link"
                  className="text-danger"
                  onClick={() =>
                    handleDeleteBanner(banner.idBanner)
                  }
                >
                  <TrashFill size={18} />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <ModalBanner
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setEditingBanner(null);
        }}
        initialData={editingBanner}
        onSuccess={fetchBanners} // 🔥 refrescar después de guardar
      />
    </Container>
  );
}

export default BannerAdmin;
